


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Meetingpage.css';
import { useNavigate } from 'react-router-dom';

const UNIFORM_COST = 549;
const MEETING_COST = 250;

const Meetingpage = () => {
  const [userName, setUserName] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [userDetails, setUserDetails] = useState(null);
  const [uniformQty, setUniformQty] = useState('');
  const [uniformSizes, setUniformSizes] = useState([]);
  const [merchantOrderId, setMerchantOrderId] = useState('');
  const [payAmount, setPayAmount] = useState('');
  const [photo, setPhoto] = useState(null);
  const [paymentScreenshot, setPaymentScreenshot] = useState(null);
  const [gender, setGender] = useState('');
  const [needsUniform, setNeedsUniform] = useState('');
  const navigate = useNavigate();
  const key = process.env.REACT_APP_KEY;

  useEffect(() => {
    setUserDetails(null);
    setMessage('');
    setUniformQty('');
    setUniformSizes([]);
    setPhoto(null);
    setPayAmount('');
    setPaymentScreenshot(null);
    setNeedsUniform('');
  }, [userName]);

  const fetchData = async (name) => {
    try {
      const check = await axios.get(`${process.env.REACT_APP_API}/meeting/getform/${name}`);
      if (check.data && check.data.length > 0) {
        navigate('/meetingticket', {
          state: { meetingData: check.data[0] },
        });
      }
    } catch (error) {
      console.error("Failed to fetch meeting form data:", error);
    }
  };

  const fetchpending = async (name) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/meeting/getpending/${name}`);
      if (response.data && response.data.length > 0) {
        alert('Waiting for approval');
        return true;
      }
      return false;
    } catch (error) {
      console.error("Failed to fetch pending meeting:", error);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      await fetchData(userName);

      const hasPending = await fetchpending(userName);
      if (hasPending) {
        setLoading(false);
        return;
      }

      const response = await axios.get(`https://erp.nalavariyam.org/api/verifyusername/${key}/${userName}`);
      if (response.data.status === 'Success') {
        setUserDetails(response.data);
        setMessage('UPI Verified. Please fill additional details.');
      } else {
        setMessage('User verification failed.');
      }
    } catch (error) {
      console.error('API Error:', error);
      setMessage('Error submitting registration. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file && !file.type.startsWith('image/')) {
      setMessage('Only image files are allowed for photo.');
      return;
    }
    setPhoto(file);
    setMessage('');
  };

  const handlePaymentScreenshotChange = (e) => {
    const file = e.target.files[0];
    if (file && !file.type.startsWith('image/')) {
      setMessage('Only image files are allowed for payment screenshot.');
      return;
    }
    setPaymentScreenshot(file);
    setMessage('');
  };

 
  const handleRegister = async () => {
    setMessage('');
    const skipUniformCheck = gender === "Female" && needsUniform === "No";

  
    if (!photo) {
      setMessage('Please upload your photo.');
      return;
    }

    if (!paymentScreenshot) {
      setMessage('Please upload a payment screenshot.');
      return;
    }

    try {
      const token = await getAuthToken();
      if (!token) return;

      const generatedOrderId = generateOrderId();
      setMerchantOrderId(generatedOrderId);

      const formData = new FormData();
      formData.append('aadhaar_no', userDetails.aadhaar_no.toString());
      formData.append('full_name', userDetails.full_name);
      formData.append('phone', userDetails.phone);
       formData.append('gender', gender);
      // formData.append('uniformQty', skipUniformCheck ? 0 : uniformQty);
      // formData.append('uniformSizes', skipUniformCheck ? '[]' : JSON.stringify(uniformSizes));
      formData.append('merchantOrderId', generatedOrderId);
      formData.append('username', userDetails.username);
      formData.append('designation', userDetails.group_name);
      formData.append('payAmount', totalCost);
      formData.append('photo', photo);
      formData.append('paymentScreenshot', paymentScreenshot);

      await axios.post(`${process.env.REACT_APP_API}/meeting/temp_meeting_form`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      alert('Submit Successful');
      window.location.reload();
    } catch (error) {
      console.error('Registration failed before payment:', error);
      setMessage('Registration failed before payment. Please try again.');
    }
  };

  const totalUniformCost = uniformQty ? UNIFORM_COST * Number(uniformQty) : 0;
  const totalCost = totalUniformCost + (userDetails ? MEETING_COST : 0);

  const getAuthToken = async () => {
    try {
      const response = await axios.post(`https://ramjitrust.org:4000/payment/get-auth-token`);
      return response.data.access_token;
    } catch (error) {
      console.error('Error fetching auth token:', error);
      setMessage('Failed to initialize payment system');
      return null;
    }
  };

  const generateOrderId = () => {
    const timestamp = Date.now();
    const random = Math.floor(Math.random() * 10000);
    return `ORD_${timestamp}_${random}`.slice(0, 63);
  };

  return (
    <div className="meeting-container">
      <h2 className="meeting-heading">Meeting Registration</h2>

      <form onSubmit={handleSubmit} className="meeting-form">
        <label className="meeting-label">Username:</label>
        <input
          type="text"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          placeholder="Enter your username"
          className="meeting-input"
          required
        />
        <button type="submit" className="meeting-button" disabled={loading}>
          {loading ? 'Verifying...' : 'Verify'}
        </button>
      </form>

      {userDetails && (
        <div className="user-info">
          <label className="meeting-label">Aadhaar No:</label>
          <input type="text" value={userDetails.aadhaar_no} readOnly className="meeting-input" />

          <label className="meeting-label">Full Name:</label>
          <input type="text" value={userDetails.full_name} readOnly className="meeting-input" />

          <label className="meeting-label">Designation:</label>
          <input type="text" value={userDetails.group_name} readOnly className="meeting-input" />

          <label className="meeting-label">Phone:</label>
          <input type="text" value={userDetails.phone} readOnly className="meeting-input" />

          <label className="meeting-label">Photo:</label>
          <input type="file" accept="image/*" className="meeting-input" onChange={handlePhotoChange} required />

          <label className="meeting-label">Gender:</label>
          <select value={gender} onChange={(e) => setGender(e.target.value)} required>
            <option value="">Select gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>

          {/* {gender === "Male" && renderUniformFields()} */}

          {/* {gender === "Female" && (
            <>
              <label className="meeting-label">Do you need a uniform?</label>
              <select value={needsUniform} onChange={(e) => setNeedsUniform(e.target.value)} required>
                <option value="">Select option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>

              {needsUniform === "Yes" && renderUniformFields()}
            </>
          )} */}

          <div className="cost-summary">
            {/* <p><strong>Uniform Cost:</strong> ₹{totalUniformCost}</p> */}
            <p><strong>Meeting Arrangement Cost:</strong> ₹{MEETING_COST}</p>
            {/* <p><strong>Total Payable Amount:</strong> <span style={{ color: 'green' }}>₹{totalCost}</span></p> */}
          </div>

          <img src="assets/images/meeting/raja.jpg" alt="Payment QR" style={{ width: '100%' }} />

          <label className="meeting-label">Payment Amount:</label>
          <input
          readOnly
            type="text"
            value={totalCost}
            // onChange={(e) => setPayAmount(e.target.value)}
            placeholder="Enter payment amount"
            className="meeting-input"
            required
          />

          <label className="meeting-label">Upload Payment Screenshot:</label>
          <input
            type="file"
            accept="image/*"
            className="meeting-input"
            onChange={handlePaymentScreenshotChange}
            required
          />

          <button type="button" className="meeting-button" onClick={handleRegister} disabled={loading}>
            {loading ? 'Processing...' : 'Register & Pay'}
          </button>
        </div>
      )}

      {message && <p className="meeting-message">{message}</p>}
    </div>
  );
};

export default Meetingpage;
